module.exports = __webpack_public_path__ + "static/media/background-cadastrar-proposta.6f005877.svg";